import React from "react";
import { Grid, Typography, Chip, Box } from "@mui/material";
import { formatNumber } from "helpers/getNumberFormats";
import { red } from "@mui/material/colors";
import { IsCreditNote } from "../IsCreditNote";
import { formatCustomDate } from "helpers/dateTools";

export const DisplayAccountCredit = ({ creditAccount = {} }) => {
  return (
    <Box >
      <Typography variant="body1">
        Credito: {formatNumber(creditAccount?.credit)} / Disponible:{" "}
        {formatNumber(creditAccount?.creditAvailability)}
      </Typography>
    </Box>
  );
};

export const ShowCreditLimit = () => {
  return (
    <Grid item xs={12}>
      <Typography
        variant="body1"
        align="right"
        style={{
          color: red[500],
        }}
      >
        Crédito insuficiente
      </Typography>
    </Grid>
  );
};

export const DisplayRequestCredit = () => {
  return (
    <Chip 
      label="Esta cuenta ha sido desbloqueada para un único servicio" 
      color="success" 
      size="small" 
    />
  );
};

export const ShowCreditSuspend = (suspendedDate=null) => {
  return (
    <Grid item xs={12}>
      <Typography
        variant="body1"
        align="right"
        style={{
          color: red[500],
        }}
      >
        {`Crédito Suspendido ${suspendedDate?.date ? formatCustomDate(suspendedDate?.date) : ``}` }
      </Typography>
    </Grid>
  );
};